import * as angular from 'angular';
import * as dispatchers from './dispatchers';
import { serviceModule } from '../services/services.module';
import actionCreatorsModule from './actionCreators.module';
import { registerServiceId } from '../registration.helper';

const dispatcherModuleId = 'wt-action-dispatchers';
const dispatcherModule = angular.module(dispatcherModuleId, [serviceModule, actionCreatorsModule]);

registerServiceId(dispatchers, dispatcherModule);

export default dispatcherModuleId;